import React from "react";
import { makeStyles } from "@material-ui/core";

export default function FunnelTopHeader({ children }) {
  const classes = useStyle();
  return <div className={classes.container}>{children}</div>;
}

const useStyle = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.primary.main,
    width: "100%",
  },
}));
